import "./TermsAndConditions.module.css";
import Header from "@/reusable_sections/Header";
import TermsConditions from "./sections/TermsConditions";
import Footer from "@/reusable_sections/Footer";
export default function TermsAndConditionsPage() {
  return <div>
      <Header />
      <TermsConditions />
      <Footer />
    </div>;
}